import { memo, useState } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import Chip from '../../Chip';

import './FlexibleOptions.scss';

const noop = () => {};

export const EXACT_DATES_OFFSET = 0;
export const ONE_WEEK_OFFSET = 7;
export const TWO_WEEKS_OFFSET = 14;
export const THREE_WEEKS_OFFSET = 21;

const getOptions = () => [
  {
    label: trans('flexible.dates.option.exact.dates'),
    isSelected: false,
    value: EXACT_DATES_OFFSET,
    dataTest: 'flexible-option-exact-dates'
  },
  {
    label: `± 1 ${trans('week.singular')}`,
    isSelected: false,
    value: ONE_WEEK_OFFSET,
    dataTest: 'flexible-option-one-week'
  },
  {
    label: `± 2 ${trans('week.plural')}`,
    isSelected: false,
    value: TWO_WEEKS_OFFSET,
    dataTest: 'flexible-option-two-weeks'
  },
  {
    label: `± 3 ${trans('week.plural')}`,
    isSelected: true,
    value: THREE_WEEKS_OFFSET,
    dataTest: 'flexible-option-three-weeks'
  }
];

const FlexibleOptions = ({
  className = '',
  value = THREE_WEEKS_OFFSET,
  onChange = noop
}) => {
  const [selectedOption, setSelectedOption] = useState(value);

  const classes = classNames('flexible-options', className);

  const clickHandler = (event, newValue) => {
    event.stopPropagation();
    event.preventDefault();

    setSelectedOption(newValue);
    onChange(newValue);
  };

  return (
    <div className={classes}>
      {getOptions().map(option => (
        <Chip.Filter
          key={option.value}
          label={option.label}
          isSelected={selectedOption === option.value}
          onClick={e => clickHandler(e, option.value)}
          dataTest={option.dataTest}
        />
      ))}
    </div>
  );
};

FlexibleOptions.propTypes = {
  className: propTypes.string,
  value: propTypes.oneOf([
    EXACT_DATES_OFFSET,
    ONE_WEEK_OFFSET,
    TWO_WEEKS_OFFSET,
    THREE_WEEKS_OFFSET
  ]),
  onChange: propTypes.func
};

export default memo(FlexibleOptions);
